import React, { Component } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import {
    Card, Tabs, Icon, Row, Col, Statistic, Divider, Form, Button, Table, Tag, Popconfirm,
    Modal, Input, Select, notification, Empty, Switch, Tooltip, DatePicker
} from "antd";
import { FormUtils as GetAllFormFields, TableComp } from "sz-react-utils";
import Request from "../../../request";
import moment from "moment";
import { RightsWrapper } from "../../../components/_utils/utils";


const { TabPane } = Tabs;
const { Option } = Select;
const invoiceCounts = [1, 2, 3, 4, 5, 6, 7, 8];

@Form.create()
class AddCommissionModal extends Component {
    state = {
        visible: true,
        bonusAny: 'No',
        bonusDetails: [],
        minimumStudents: '',
        maximumStudents: '',
        bonusType: 'Per Student',
        commissionType: 'flat',
        bonus: '',
        bonusIndex: null,
    }

    updateCommissionFromUniversity = () => {
        const { form: { getFieldValue, setFieldsValue } } = this.props;

        const partnerCommission = Number(getFieldValue('partnerCommission')) || 0;
        const commissionProvided = Number(getFieldValue('commissionProvided')) || 0;
        const basis = getFieldValue('commissionBasis');
        const type = getFieldValue('commissionTypeFrom');

        if (type === "Percentage" && basis === "Gross") {
            const commissionPercent = (partnerCommission * commissionProvided) / 100;
            setFieldsValue({
                commissionFromUniversity: Number(commissionPercent.toFixed(2)) // numeric only
            });
        }
    }


    addBonusCommission = () => {
        const { minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusDetails } = this.state;
        if (!minimumStudents || !bonus) {
            return notification.warning({ message: 'Please fill required bonus fields' });
        }
        const newBonus = { minimumStudents, maximumStudents, bonusType, commissionType, bonus };
        this.setState({
            bonusDetails: [...bonusDetails, newBonus],
            minimumStudents: '', maximumStudents: '', bonus: '', bonusIndex: null
        });
    }

    updateBonusCommission = () => {
        const { bonusIndex, bonusDetails, minimumStudents, maximumStudents, bonusType, commissionType, bonus } = this.state;
        let newList = [...bonusDetails];
        newList[bonusIndex] = { minimumStudents, maximumStudents, bonusType, commissionType, bonus };
        this.setState({
            bonusDetails: newList,
            minimumStudents: '', maximumStudents: '', bonus: '', bonusIndex: null
        });
    }


    componentDidMount() {
        let { selectedApplicant, form } = this.props;
        if (selectedApplicant) {
            this.setState({
                bonusDetails: selectedApplicant.bonusDetails || [],
                bonusAny: selectedApplicant.bonusAny || "No",
            }, () => {
                form.setFieldsValue({ ...selectedApplicant }, () => {
                    setTimeout(() => {
                        form.setFieldsValue({ commissionProvided: selectedApplicant.commissionProvided, partnerCommission: selectedApplicant.partnerCommission });
                    }, 50)
                })
            })
        }
    }

    editBonus = (index, item) => {
        this.setState({
            bonusIndex: index,
            minimumStudents: item.minimumStudents,
            maximumStudents: item.maximumStudents,
            bonusType: item.bonusType,
            commissionType: item.commissionType,
            bonus: item.bonus
        });
    }

    removeBonus = (index) => {
        const filtered = this.state.bonusDetails.filter((_, i) => i !== index);
        this.setState({ bonusDetails: filtered });
    }

    handleCommListSubmit = () => {
        let { form } = this.props;

        let applicantFromValues = form.getFieldsValue([
            'studyType',
            'term',
            'commissionTypeFrom',
            'commissionBasis',
            'partnerCommission',
            'commissionFromUniversity',
            'commissionProvided',
            'commissionFromUniversity'
        ]);

        // ✅ VALIDATIONS
        if (!applicantFromValues.term) {
            notification.error({ message: 'Expect Term Number!' });
            return;
        }

        if (!applicantFromValues.commissionTypeFrom) {
            notification.error({ message: 'Expect Commission Type!' });
            return;
        }

        if (!applicantFromValues.commissionFromUniversity) {
            notification.error({ message: 'Expect Commission Amount' });
            return;
        }


        const newRecord = {
            ...applicantFromValues,
            bonusAny: this.state.bonusAny,
            bonusDetails: this.state.bonusDetails
        };

        this.props.onSubmit(newRecord);

    };

    handleRemoveComm = (index) => {

        let applicantsList = [...this.state.applicantsList];

        applicantsList.splice(index, 1);

        this.setState({
            applicantsList
        });

    };

    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator, setFieldsValue, getFieldValue }, isOnshoreOffshoreAvailable, numberOfInvoices,
            editIndex } = this.props;
        const modalSchema = {
            fields: [
                {
                    label: 'Study Location',
                    key: 'studyType',
                    type: 'select',
                    options: ['Offshore', 'Onshore'],
                    hidden: isOnshoreOffshoreAvailable !== "yes",
                    required: isOnshoreOffshoreAvailable === "yes",
                    onChange: v => {
                        setFieldsValue({ studyType: v })
                    }
                },
                {
                    label: 'Term / Intake Number',
                    key: 'term',
                    type: 'select',
                    options: Array.from({ length: numberOfInvoices }, (_, i) => ({ _id: i + 1, display: `Term ${i + 1}` })),
                    required: true,
                    onChange: v => {
                        setFieldsValue({ term: v })
                    }
                },
                {
                    label: 'Commission Structure',
                    key: 'commissionTypeFrom',
                    type: 'select',
                    options: ['Flat', 'Percentage'],
                    required: true,
                    onChange: v => {
                        setFieldsValue({ commissionTypeFrom: v })
                    }
                },
                {
                    label: 'Commission Calculated On',
                    key: 'commissionBasis',   // ✅ fixed spelling
                    type: 'select',
                    hidden: !getFieldValue('commissionTypeFrom') || getFieldValue('commissionTypeFrom') === "Flat",
                    required: getFieldValue('commissionTypeFrom') === "Percentage",
                    showSearch: true,
                    disabled: false,
                    options: [
                        { _id: 'Net', display: 'Net Percentage' },
                        { _id: 'Gross', display: 'Gross Percentage' },
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            commissionBasis: v   // ✅ matches the key
                        })
                    }
                },
                {
                    label: 'Partner Commission',
                    key: 'partnerCommission',
                    type: 'inputNumber',  // ensures numeric value
                    hidden: !getFieldValue('commissionBasis') || getFieldValue('commissionBasis') === "Net",
                    required: getFieldValue('commissionBasis') === "Gross",
                    onChange: v => {
                        // v is already a number, store directly
                        setFieldsValue({ partnerCommission: v.target.value }, () => {
                            this.updateCommissionFromUniversity()
                        });
                    }
                },
                {
                    label: 'Commission Provided',
                    key: 'commissionProvided',
                    type: 'inputNumber',  // ensures numeric value
                    hidden: !getFieldValue('commissionBasis') || getFieldValue('commissionBasis') === "Net",
                    required: getFieldValue('commissionBasis') === "Gross",
                    onChange: v => {
                        // v is already a number, store directly
                        setFieldsValue({ commissionProvided: v.target.value }, () => {
                            this.updateCommissionFromUniversity()
                        });
                    }
                },
                {

                    label: 'Commission Amount / %',
                    key: 'commissionFromUniversity',
                    required: true,
                    disabled: (() => {
                        const type = getFieldValue('commissionTypeFrom');
                        const basis = getFieldValue('commissionBasis');

                        if (type === "Flat") return false;
                        if (type === "Percentage" && basis === "Gross") return true;
                        if (type === "Percentage" && basis === "Net") return false;
                        return true;
                    })(),
                },
                {
                    label: 'Add Bonus?', key: 'bonusAny', type: 'select', options: [{ _id: 'Yes', display: 'Yes' }, { _id: 'No', display: 'No' }], onChange: v => {
                        setFieldsValue({ bonusAny: v }, () => {
                            this.setState({ bonusAny: v })
                        })
                    }
                }
            ]
        };
        return (
            <Modal
                destroyOnClose
                title={
                    <span>
                        <Icon type="percentage" /> Commission & Bonus Setup
                    </span>
                }
                visible={visible}
                width={900}
                onCancel={() =>
                    this.setState({
                        visible: false,
                        bonusAny: null,
                        bonusDetails: [],
                    })
                }
                footer={[
                    <Button
                        key="back"
                        onClick={() =>
                            this.setState({
                                showApplicantModal: false,
                            })
                        }
                    >
                        Cancel
                    </Button>,

                    <Button
                        key="submit"
                        type="primary"
                        icon={editIndex !== null ? "edit" : "plus-square"}
                        onClick={this.handleCommListSubmit}
                    >
                        {editIndex !== null
                            ? "Update"
                            : "Add to Main List"}
                    </Button>
                ]}
            >
                <Form layout="horizontal">
                    <GetAllFormFields
                        inputSchema={modalSchema}
                        getFieldDecorator={this.props.form.getFieldDecorator}
                    />

                    {/* ✅ BONUS SECTION */}
                    {this.state.bonusAny === 'Yes' && (
                        <Card
                            title={
                                <span>
                                    <Icon type="gift" /> Bonus Logic
                                </span>
                            }
                            style={{ marginTop: 20, background: '#fafafa' }}
                        >
                            <Row gutter={12} align="bottom" type="flex">
                                <Col span={4}>
                                    <label>Min Qty</label>
                                    <Input
                                        type="number"
                                        placeholder="Min"
                                        value={this.state.minimumStudents}
                                        onChange={e =>
                                            this.setState({
                                                minimumStudents: e.target.value
                                            })
                                        }
                                    />
                                </Col>

                                <Col span={4}>
                                    <label>Max Qty</label>
                                    <Input
                                        type="number"
                                        placeholder="Max"
                                        value={this.state.maximumStudents}
                                        onChange={e =>
                                            this.setState({
                                                maximumStudents: e.target.value
                                            })
                                        }
                                    />
                                </Col>

                                <Col span={5}>
                                    <label>Bonus Calculation</label>
                                    <Select
                                        style={{ width: '100%' }}
                                        value={this.state.bonusType}
                                        onChange={v =>
                                            this.setState({ bonusType: v })
                                        }
                                    >
                                        <Option value="Per Student">Per Student</Option>
                                        <Option value="Total Student">Total Student</Option>
                                    </Select>
                                </Col>

                                <Col span={5}>
                                    <label>Value Type</label>
                                    <Select
                                        style={{ width: '100%' }}
                                        value={this.state.commissionType}
                                        onChange={v =>
                                            this.setState({ commissionType: v })
                                        }
                                    >
                                        <Option value="flat">Flat Amount</Option>
                                        <Option value="percantage">Percentage</Option>
                                    </Select>
                                </Col>

                                <Col span={4}>
                                    <label>Value</label>
                                    <Input
                                        type="number"
                                        placeholder="Value"
                                        value={this.state.bonus}
                                        onChange={e =>
                                            this.setState({ bonus: e.target.value })
                                        }
                                    />
                                </Col>

                                <Col span={2}>
                                    <Button
                                        type="primary"
                                        ghost
                                        icon={
                                            this.state.bonusIndex !== null
                                                ? "edit"
                                                : "plus"
                                        }
                                        onClick={
                                            this.state.bonusIndex !== null
                                                ? this.updateBonusCommission
                                                : this.addBonusCommission
                                        }
                                    >
                                        {this.state.bonusIndex !== null
                                            ? "Update"
                                            : "Add"}
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                size="small"
                                style={{ marginTop: 15 }}
                                dataSource={this.state.bonusDetails}
                                pagination={false}
                                rowKey={(r, i) => i}
                                columns={[
                                    {
                                        title: 'Range',
                                        render: r =>
                                            `${r.minimumStudents} - ${r.maximumStudents || '∞'}`
                                    },
                                    { title: 'Calc', dataIndex: 'bonusType' },
                                    { title: 'Type', dataIndex: 'commissionType' },
                                    { title: 'Bonus', dataIndex: 'bonus' },
                                    {
                                        title: 'Action',
                                        render: (_, r, i) => (
                                            <span>
                                                <a onClick={() => this.editBonus(i, r)}>
                                                    Edit
                                                </a>
                                                <Divider type="vertical" />
                                                <a
                                                    className="text-danger"
                                                    onClick={() =>
                                                        this.removeBonus(i)
                                                    }
                                                >
                                                    Delete
                                                </a>
                                            </span>
                                        )
                                    }
                                ]}
                            />
                        </Card>
                    )}
                </Form>
            </Modal>
        )
    }
}

@Form.create()
class ChannelPartnerCommission extends Component {
    state = {
        total: 0,
        activeTab: '0',
        partners: [],
        universities: [],
        campusIds: [],
        numberOfInvoices: 0,
        levelOptions: [],
        isOnshoreOffshoreAvailable: null,
        applicantsList: [],
        showApplicantModal: false,
        editIndex: null,
        selectedApplicant: null,
        loading: false,
        activeStatus: true
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    loadPartnerUniversities = async (partnerId) => {
        let resp = await Request.getChannelPartnerUniversities(partnerId);
        resp.data = resp.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.universityInstitutionName });
            return temp;
        }, []);
        let channelPartner = resp && resp.channelPartner ? resp.channelPartner : [];
        this.setState({ universities: resp.data, fullAgreement: channelPartner && channelPartner.paymentUpload ? channelPartner.paymentUpload : [], commmissionPage: channelPartner && channelPartner.paymentUploadCommissionPage ? channelPartner.channelPartner : [] });
    }

    loadLevels = async () => {
        Request.loadSimpleLevels({ sortField: 'levelName', sortOrder: 'ascend' })
            .then(resp => {
                let temp = [{ display: '---Select All---', id: 'all' }];
                const formatted = (resp.data || []).map(vv => ({ _id: vv._id, display: vv.levelName }));
                this.setState({ levelOptions: [...temp, ...formatted] });
            }).catch(console.error);
    }

    loadChannelPartners = async () => {
        let res = await Request.loadChannelPartners();
        res.data = res.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.channelPartnerName });
            return temp;
        }, []);
        this.setState({ partners: res.data });
    }

    componentDidMount() {
        this.loadChannelPartners();
        this.loadLevels();
    }



    loadUniversityCampus = async (universityId) => {
        let { data } = await Request.loadUniCampus(universityId);
        let temp = [{ display: '---Select All---', _id: 'all' }];
        const formatted = (data || []).map(vv => ({ _id: vv._id, display: vv.campusName }));
        this.setState({ campusIds: [...temp, ...formatted] });
    }

    handleApplicant = (e) => {
        let { applicantsList, editIndex } = this.state;
        if (editIndex !== null && editIndex !== undefined) {
            // 👉 UPDATE
            applicantsList[editIndex] = e;
        } else {
            // 👉 ADD
            applicantsList.push(e);
        }


        this.setState({ showApplicantModal: false, editIndex: null, applicantsList, selectedApplicant: null });

    }


    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                values.commDetails = this.state.applicantsList;
                let x = null;
                if (this.state.id) {
                    values._id = this.state.id;
                    x = await Request.updateChannelPartnerCommission(values);
                } else {
                    x = await Request.addChannelPartnerCommission(values);
                }
                if (!x.error) {
                    this.setState({
                        id: '',
                        activeTab: '0',
                    })
                    notification.success({
                        message: this.state.id
                            ? `Commission Updated Successfully`
                            : 'Commission Added successfully'
                    })
                    if (!this.state.id) {
                        form.resetFields()
                    }
                    if (this.table && this.table.current)
                        this.table.current.reload()

                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        });
    }


    handleEditComm = (record, index) => {
        let applicantList = this.state.applicantsList;
        this.setState({ selectedApplicant: applicantList[index], showApplicantModal: true, editIndex: index });
    };

    handleRemoveComm = (index) => {

        let applicantsList = [...this.state.applicantsList];

        applicantsList.splice(index, 1);

        this.setState({
            applicantsList
        });

    };


    deleteCommission = async data => {
        this.setState({ loading: true })
        await Request.deleteChannelPartnerCommission(data)

        this.setState({ loading: false })

        this.table.current.reload()

        notification.success({
            message: 'Deleted Successfully',
            duration: 20,
            key: `${data._id}-close`
        })
    }

    updateActiveStatus = async (recordId, activeStatus) => {
        let response = await Request.updateChannelPartnerCommActiveStatus({ _id: recordId, activeStatus });
        console.log(response);
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.messsage
            })
        }
        this.table.current.reload();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { activeStatus } = this.state;
            params.activeStatus = activeStatus;
            this.setState({ exportParams: params })
            let data = await Request.getChannelPartnerCommission({
                ...params,
                regExFilters: [
                    'universityInstitutionName'
                ]
            });
            this.setState({ total: data.total })
            resolve(data)
        })
    }


    setCommissionData(commissionId) {
        if (commissionId) {
            Request.getCPCommissionById({ id: commissionId }).then(
                ({ doc, error, message }) => {
                    if (!error && doc) {

                        let universityId = '';
                        let channelPartnerId = '';
                        if (doc.universityId && doc.universityId._id) {
                            universityId = doc.universityId._id;
                        } else {
                            universityId = doc.universityId;
                        }

                        if (doc.channelPartnerId && doc.channelPartnerId._id) {
                            channelPartnerId = doc.channelPartnerId._id;
                        } else {
                            channelPartnerId = doc.channelPartnerId;
                        }

                        this.setState({
                            id: doc._id,
                            activeTab: '2',
                            bonusAny: doc.bonusAny,
                            bonusDetails: doc.bonusDetails || [],
                            applicantsList: doc.commDetails || [],
                            isOnshoreOffshoreAvailable: doc.isOnshoreOffshoreAvailable || null,
                            numberOfInvoices: doc.noOfInvoice
                        });

                        this.props.form.setFieldsValue({
                            channelPartnerId: channelPartnerId,
                            universityId: universityId,
                            campusIds: doc.campusIds || [],
                            courseLevelId: doc.courseLevelId || [],
                            paymentTimeline: doc.paymentTimeline,
                            invoicePerYear: doc.invoicePerYear,
                            noOfInvoice: doc.noOfInvoice,
                            typeOfCommission: doc.typeOfCommission,
                            isOnshoreOffshoreAvailable: doc.isOnshoreOffshoreAvailable,
                            incentive: doc.incentive
                        });

                        if (universityId) {
                            this.loadUniversityCampus(universityId);
                        }

                    } else {
                        notification.error({
                            message: 'Error Getting Data',
                            description: message
                        });
                    }
                }
            );
        }
    }

    render() {
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let { total, activeTab, partners, universities, campusIds, levelOptions, isOnshoreOffshoreAvailable,
            applicantsList, showApplicantModal, numberOfInvoices, editIndex, selectedApplicant, loading
        } = this.state;
        let types = ['Base', 'Special'];

        const normalizeCommission = (record) => {
            if (record.commDetails && record.commDetails.length) {
                return record.commDetails;
            }

            if (record.commissionFromUniversity) {
                return [{
                    term: 1,
                    commissionFromUniversity: record.commissionFromUniversity,
                    commissionTypeFrom: record.commissionTypeFrom
                }];
            }

            return [];
        };


        const mainFormSchema = {
            fields: [
                {
                    label: 'Select Channel Partner',
                    key: 'channelPartnerId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    options: partners,
                    onChange: v => {
                        setFieldsValue({ channelPartnerId: v }, () => {
                            this.loadPartnerUniversities(v);
                        });
                    }
                },
                {
                    label: 'Select University',
                    key: 'universityId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    options: universities,
                    onChange: v => {
                        setFieldsValue({ universityId: v }, () => {
                            this.loadUniversityCampus(v);
                        });
                    }
                },
                {
                    label: 'Commission Type',
                    key: 'typeOfCommission',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    options: ['Base', 'Special'],
                    onChange: v => {
                        setFieldsValue({ typeOfCommission: v });
                    }
                },
                {
                    label: 'Campus',
                    key: 'campusIds',
                    type: 'select',
                    mode: 'multiple',
                    options: campusIds,
                    required: campusIds && campusIds.length > 1 ? true : false,
                    span: 12,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === campusIds.length) {
                                val = [];
                            } else {
                                val = campusIds.slice(1).map(campusOption => campusOption._id);
                            }
                        }
                        setFieldsValue({
                            campusIds: val
                        })
                    }
                },
                {
                    label: 'Course Levels',
                    key: 'courseLevelId',
                    type: 'select',
                    mode: 'multiple',
                    options: levelOptions,
                    required: true,
                    span: 12,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === levelOptions.length) {
                                val = [];
                            } else {
                                val = levelOptions.slice(1).map(levelOption => levelOption._id);
                            }
                        }
                        setFieldsValue({
                            courseLevelId: val
                        })
                    }
                },
                {
                    label: 'No. of Invoices',
                    key: 'noOfInvoice',
                    type: 'select',
                    options: invoiceCounts,
                    required: true,
                    span: 6,
                    onChange: v => {
                        setFieldsValue({ noOfInvoice: v }, () => {
                            this.setState({ numberOfInvoices: v })
                        })
                    }
                },
                {
                    label: 'Invoices Per Year',
                    key: 'invoicePerYear',
                    type: 'select',
                    options: invoiceCounts,
                    required: true,
                    span: 6,
                    onChange: v => {
                        setFieldsValue({ invoicePerYear: v })
                    }
                },
                {
                    label: 'Onshore/Offshore Differentiation?',
                    key: 'isOnshoreOffshoreAvailable',
                    type: 'select',
                    required: true,
                    span: 12,
                    options: [{ _id: 'yes', display: 'Yes' }, { _id: 'no', display: 'No' }],
                    onChange: v => {
                        setFieldsValue({ isOnshoreOffshoreAvailable: v }, () => {
                            this.setState({ isOnshoreOffshoreAvailable: v, applicantsList: [], showApplicantModal: false, editIndex: null })
                        })
                    }
                }
            ]
        };
        const columns = [
            { title: 'Term', dataIndex: 'term', render: t => `Term ${t}` },
            { title: 'Type', dataIndex: 'studyType', render: s => s || 'N/A' },
            { title: 'Value', render: (r) => `${r.commissionFromUniversity} ${r.commissionTypeFrom === 'Percentage' ? '%' : '(Flat)'}` },
            { title: 'Bonus', render: (r) => r.bonusAny === 'Yes' ? <Tag color="gold">{r.bonusDetails.length} Rules</Tag> : 'No' },
            {
                title: 'Action',
                key: 'action',
                render: (text, record, index) => (
                    <span>
                        <Button
                            type="link"
                            icon="edit"
                            onClick={() => this.handleEditComm(record, index)}
                        />
                        <Popconfirm
                            title="Are you sure remove this commission?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => this.handleRemoveComm(index)}
                        >
                            <Button
                                type="link"
                                icon="delete"
                                className="text-danger"
                            />
                        </Popconfirm>
                    </span>

                )
            }
        ];

        const mainColumns = [
            {
                title: 'Channel Partner Name',
                key: 'channelPartnerName',
                width: 250,
                dataIndex: 'channelPartnerId.channelPartnerName',
                searchTextName: 'Channel Partner Name'
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                width: 250,
                dataIndex: 'universityInstitutionName',
                searchTextName: "University Name",
            },
            {
                title: 'Commission',
                key: 'commissionFromUniversity',
                render: (text, record) => {
                    const commissions = normalizeCommission(record);

                    if (!commissions.length) return '-';

                    return commissions.map((item, index) => (
                        <div key={index}>
                            {commissions.length > 1 ? `Term ${item.term}: ` : ''}
                            {item.commissionFromUniversity}{' '}
                            {item.commissionTypeFrom === 'Percentage' ? '%' : '(Flat)'}
                        </div>
                    ));
                }
            },

            {
                title: 'Country',
                key: 'universityCountryName',
                dataIndex: 'universityId.universityCountryName',
                searchTextName: 'Country Name'
            },

            {
                title: 'Total No Of Invoices / Invoice Per Year',
                key: 'noOfInvoice',
                render: (text, record) => (
                    <div>{record.noOfInvoice}/{record.invoicePerYear}</div>
                )
            },

            {
                title: 'Payment Due (Days)',
                key: 'paymentTimeline',
                dataIndex: 'channelPartnerId.paymentTimeline'
            },

            // {
            //     title: 'Commission Type',
            //     key: 'commissionTypeFrom',
            //     filters: [
            //         { text: 'Flat', value: 'Flat' },
            //         { text: 'Percentage', value: 'Percentage' }
            //     ],
            //     render: (text, record) => {

            //         if (record.commDetails && record.commDetails.length) {
            //             return record.commDetails[0].commissionTypeFrom;
            //         }

            //         if (record.commissionTypeFrom) {
            //             return record.commissionTypeFrom;
            //         }

            //         return '-';
            //     }
            // },

            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',
                filters: [
                    { text: 'Pending', value: 'Pending' },
                    { text: 'Active', value: 'Active' },
                    { text: 'Inactive', value: 'Inactive' }
                ]
            },
            {
                title: 'Active Status',
                key: 'activeStatus',
                dataIndex: 'activeStatus',
                render: (text, record) => {
                    return (
                        <Switch
                            checked={record.activeStatus}
                            onChange={(checked) =>
                                this.updateActiveStatus(record._id, checked)
                            }
                        />
                    );
                }
            },
            {
                title: 'Updated By',
                key: 'updatedBy',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <DatePicker
                            value={selectedKeys[0]}
                            onChange={(date) => setSelectedKeys(date ? [date] : [])}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Button type="primary" onClick={confirm} size="small">
                            Filter
                        </Button>
                        <Button onClick={clearFilters} size="small">
                            Reset
                        </Button>
                    </div>
                ),

                render: (text, record) => {
                    const user = record.updatedByUser || record.createdByUser;

                    return (
                        <div>
                            <div>{user ? user.name : ''}</div>
                            <small>
                                {user ? moment(user.time).format('lll') : ''}
                            </small>
                        </div>
                    );
                }
            },
            {
                title: 'Approved By',
                key: 'approvedBy',

                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <DatePicker
                            value={selectedKeys[0]}
                            onChange={(date) => setSelectedKeys(date ? [date] : [])}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Button type="primary" onClick={confirm} size="small">
                            Filter
                        </Button>
                        <Button onClick={clearFilters} size="small">
                            Reset
                        </Button>
                    </div>
                ),

                render: (text, record) => {
                    const user = record && record.status === "Active" && record.approvedBy;

                    return (
                        <div>
                            <div>{user ? user.name : ''}</div>
                            <small>
                                {user ? moment(user.time).format('lll') : ''}
                            </small>
                        </div>
                    );
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <>
                        <RightsWrapper myRight={'financeUniversityCommission.edit'}>
                            <Tooltip title="Edit Commission">
                                <Button

                                    shape="circle"
                                    onClick={() =>
                                        this.setCommissionData(record._id)
                                    }
                                    icon="edit"
                                />
                            </Tooltip>
                        </RightsWrapper>

                        <RightsWrapper myRight={'financeUniversityCommission.delete'}>
                            <Tooltip title="Delete Commission">
                                <Popconfirm
                                    title="Are you sure delete this Commission?"
                                    onConfirm={() =>
                                        this.deleteCommission({ _id: record._id })
                                    }
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button

                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </>
                )
            }
        ];
        return (
            <PageHeaderWrapper title={`Channel Partner Commission:`}>
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Button type="primary" onClick={() => this.setState({ activeStatus: !this.state.activeStatus }, () => this.table.current.reload())}>{this.state.activeStatus ? 'Inactive Commission' : "Active Commission"}</Button>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={(v) => this.setState({ activeTab: v })}
                        type="line"
                    >

                        {types.map((type, index) => (
                            <TabPane
                                tab={<span><Icon type="unordered-list" />{type} Commissions</span>}
                                key={String(index)}
                            >
                                <Row gutter={16} style={{ marginBottom: 20 }}>
                                    <Col span={6}>
                                        <Card style={{ background: '#f0f2f5' }}>
                                            <Statistic title={`Total ${type} Commissions`} value={total} prefix={<Icon type="file-done" />} />
                                        </Card>
                                    </Col>
                                </Row>
                                {activeTab === String(index) && (
                                    <TableComp
                                        ref={this.table}
                                        columns={mainColumns}
                                        apiRequest={(params) =>
                                            this.apiRequest({ ...params, typeOfCommission: type })
                                        }
                                        extraProps={{ scroll: { x: 1400 } }}
                                        locale={{ emptyText: <Empty description="No commissions configured yet." /> }}
                                        pagination={{
                                            showSizeChanger: true,
                                            defaultPageSize: 50,
                                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                                        }}
                                    />
                                )}
                            </TabPane>
                        ))}

                        <TabPane tab={<span><Icon type="plus-circle" />Add New Commission</span>} key="2">
                            {
                                showApplicantModal ?
                                    <AddCommissionModal onSubmit={(e) => this.handleApplicant(e)} selectedApplicant={selectedApplicant} isOnshoreOffshoreAvailable={isOnshoreOffshoreAvailable} applicantsList={applicantsList} numberOfInvoices={numberOfInvoices} editIndex={editIndex} onClose={() => this.setState({ showApplicantModal: false, editIndex: null })} />
                                    : null
                            }
                            <Form onSubmit={this.handleSubmit} layout="vertical">
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider orientation="left">1. Partner & University Details</Divider>
                                        <GetAllFormFields
                                            inputSchema={mainFormSchema}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </Col>
                                </Row>
                                {isOnshoreOffshoreAvailable && (
                                    <div style={{ marginTop: 30 }}>
                                        <Divider orientation="left">2. Commission Breakdowns</Divider>
                                        <Card title="Detailed Terms" extra={<Button type="primary" ghost icon="plus" onClick={() => this.setState({ showApplicantModal: true })}>Add Breakdown</Button>}>
                                            <Table
                                                bordered
                                                size="small"
                                                dataSource={applicantsList}
                                                columns={columns}
                                                pagination={false}
                                            />
                                        </Card>
                                    </div>
                                )}
                                <div style={{ textAlign: 'right', marginTop: 40 }}>

                                    <Button type="primary" size="large" htmlType="submit" loading={loading} icon="save">
                                        Save Commission
                                    </Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Card>

                {/* Breakdown Modal */}

            </PageHeaderWrapper>
        )
    }
}


export default ChannelPartnerCommission;